import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "fontSize", "marginBlockStart"];
import { Body } from './Body';
import { BodySmall } from './BodySmall';
import { jsx as _jsx } from "react/jsx-runtime";
const labelMarginMap = {
  base: '-space-3xs',
  sm: 'space-4xs',
  md: '-space-3xs',
  lg: '-space-3xs'
};
export const InputLabel = _ref => {
  let {
      children,
      fontSize = 'base',
      marginBlockStart: providedMarginBlockStart
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const marginBlockStart = providedMarginBlockStart !== null && providedMarginBlockStart !== void 0 ? providedMarginBlockStart : labelMarginMap[fontSize];
  if (fontSize === 'sm') {
    return /*#__PURE__*/_jsx(BodySmall, Object.assign({
      as: "span",
      display: "block",
      marginBlockStart: marginBlockStart
    }, rest, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(Body, Object.assign({
    as: "span",
    display: "block",
    fontSize: fontSize,
    marginBlockStart: marginBlockStart
  }, rest, {
    children: children
  }));
};